import { Link } from 'react-router-dom';
import { buildCategoryPath } from '@/utils/articles';

const toneMap: Record<string, string> = {
  'mingxing-bagua': 'bg-primary-100 text-primary-800 hover:bg-primary-200',
  'wanghong-fanche': 'bg-accent-100 text-accent-900 hover:bg-accent-200',
  'suran-tougao': 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200',
  'quannei-neimu': 'bg-foreground-100 text-foreground-800 hover:bg-foreground-200',
};

interface CategoryTagProps {
  slug: string;
  name: string;
  size?: 'sm' | 'md';
}

export default function CategoryTag({ slug, name, size = 'sm' }: CategoryTagProps) {
  const tone = toneMap[slug] || 'bg-background-200 text-foreground-800';
  const padding = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <Link
      to={buildCategoryPath(slug)}
      className={`inline-flex items-center whitespace-nowrap rounded-full font-medium transition-colors ${tone} ${padding}`}
    >
      {name}
    </Link>
  );
}